export default {
  PAGE_CONFIG : 'PAGE_CONFIG',
  GET_LEAGUES : 'GET_LEAGUES',
  GET_SCOREBOARD : 'GET_SCOREBOARD',
  GET_SCOREBOARD_REQUEST : 'GET_SCOREBOARD_REQUEST',
  GET_SCOREBOARD_FAILURE : 'GET_SCOREBOARD_FAILURE',
  GET_STANDINGS : 'GET_STANDINGS',
  GET_FIXTURES : 'GET_FIXTURES',
  GET_HEADLINES : 'GET_HEADLINES',
  GET_GAMEPACKAGE : 'GET_GAMEPACKAGE',
  GET_PLAY_BY_PLAY : 'GET_PLAY_BY_PLAY',
  GET_VIDEOS_MORE : 'GET_VIDEOS_MORE',
  GET_GEO_LOCATION : 'GET_GEO_LOCATION',
  GET_RENDERED_ARTICLE : 'GET_RENDERED_ARTICLE',
  SET_DEVICE_TYPE : 'SET_DEVICE_TYPE',
  HISTORY_CHANGE : 'HISTORY_CHANGE',
  UPDATE_TIMEZONE : 'UPDATE_TIMEZONE',
  API_REQUEST_START : 'API_REQUEST_START',
  API_REQUEST_COMPLETE : 'API_REQUEST_COMPLETE',
  GET_CLUBHOUSE : 'GET_CLUBHOUSE',
  GET_MORE_MID_COL_FEED : 'GET_MORE_MID_COL_FEED',
  APP_PROPS : 'APP_PROPS',
  COMM_FB_STATUS : 'COMM_FB_STATUS',
  ALLOW_DENY_FASTCAST : 'ALLOW_DENY_FASTCAST',
  UPDATE_GAMESTRIP_TIME : 'UPDATE_GAMESTRIP_TIME'
}



/** WEBPACK FOOTER **
 ** ../app/constants/actionTypes.js
 **/